"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSmartState = void 0;
var react_fast_compare_1 = __importDefault(require("react-fast-compare"));
var react_1 = require("react");
var useSmartState = function (initState) {
    var _a = __read((0, react_1.useState)(initState), 2), state = _a[0], setState = _a[1];
    var smartSetState = function (newState) {
        if (!(0, react_fast_compare_1.default)(state, newState)) {
            setState(newState);
        }
    };
    return [state, smartSetState];
};
exports.useSmartState = useSmartState;
